module.exports = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]